export const GEO_IP = {
  ENDPOINT: "geo-ip",
  QUERY_KEY: ["geo-ip"]
}

export const DEAULT_LIST_PARAMS = {
  PAGE: 1,
  LIMIT: 10
}

export const DEFAULT_LIST_PARAMS_FOR_SESSION_PAGE = {
  PAGE: 1,
  LIMIT: 999
}
